import React, { useEffect } from 'react'

import ScreenLoader from '@/components/ScreenLoader'
import { urlQuery } from '@/lib'
import dayjs from 'dayjs'
import { useStore } from '@/store'
import Header from './Header'
import { request } from '@/lib/axios'
import RotateNotice from '@/components/RotateNotice'
type Props = {
  children: React.ReactNode
}

const MainLayout: React.FC<Props> = ({
  children
}) => {

  const { updateState } = useStore()

  useEffect(() => {
    const garena_token = urlQuery('garena_token') || urlQuery('access_token')
    // let clientLogged = localStorage.getItem('garena_token')
    let checkString = garena_token + dayjs().format('DD-MM-YYYY-mm') + import.meta.env.VITE_APP_PROJECT_NAME

    // if(garena_token && checkString != clientLogged && garena_token.length >= 64) {
    if(garena_token) {
      request.get(`${window.location.origin}/connect/garena/callback?${garena_token.length > 70 ? 'garena_token' : 'access_token'}=${garena_token}&source_type=ingame`).then(() => {
        updateState('loginSuccess', true)
        localStorage.setItem('garena_token', checkString)
        // if(response.status == 'success') {
        //   updateState('loginSuccess', true)
        //   localStorage.setItem('garena_token', checkString)
        //   // window.location.reload()
        // }
      })
    }
  }, [])

  return (
    <>
    <RotateNotice />
    <ScreenLoader />
    <div className="decor-birds" aria-hidden="true">
      <img className="decor-bird decor-bird-one" src="/images/decor-bird.png" alt="" />
      <img className="decor-bird decor-bird-two" src="/images/decor-bird-2.png" alt="" />
    </div>
    <Header />
      <section id="main-body">
        {children}
      </section>
    </>
  )
}

export default MainLayout
